/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Placeflyerliveroomhint4Inputs */

const en_placeflyerliveroomhint4 = /** @type {(inputs: Placeflyerliveroomhint4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For the bar, tables and entrance: when something's on, someone opens the Live Room and friends see who's here.`)
};

const de_placeflyerliveroomhint4 = /** @type {(inputs: Placeflyerliveroomhint4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Für Bar, Tische und Eingang: Wenn hier was los ist, macht jemand den Live Room auf und Freunde sehen, wer da ist.`)
};

/**
* | output |
* | --- |
* | "For the bar, tables and entrance: when something's on, someone opens the Live Room and friends see who's here." |
*
* @param {Placeflyerliveroomhint4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const placeflyerliveroomhint4 = /** @type {((inputs?: Placeflyerliveroomhint4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Placeflyerliveroomhint4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_placeflyerliveroomhint4(inputs)
	return de_placeflyerliveroomhint4(inputs)
});
export { placeflyerliveroomhint4 as "placeFlyerLiveRoomHint" }